import { current } from '@reduxjs/toolkit'
import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
/* import {
    Schools, Subject,
    SixthPeriodAssignmentInitiateReport,
    SixthPeriodReportTransactionCycle,
    TimeReportInitiateReport,
    TimeReportTransactionCycle,
    TimeReportEmployee,
    TimeReportEmployeeDetails,
    Employee,

} from "../../models"; */
import { GetValueFromArray, graphQLGetAllData, graphQLFindRecordById } from '../../helper/commonfunctions';
/* import { DataStore, Predicates, SortDirection } from '@aws-amplify/datastore'; */
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import handleDateSelect from '../../helper/convertDateIntoPSTFormat';

const HtmlToPdfTimeReport = (props) => {

    console.log("Props-->", props);
    // console.log("specificReportDetailsspecificReportDetailsspecificReportDetails:-abc", props.specificReportDetails);
    const [viewEmployeeDetailsData, setViewEmployeeDetailsData] = useState([]);
    const [pages, setPages] = useState([]);
    const [allApproverList, setAllApproverList] = useState([]);
    const [submittedBy, setSubmittedBy] = useState('');
    const [totalRowspan, settotalRowspan] = useState('');

    // var dates = [];
    // var months = [];
    // var datesLength = [];
    // var totalRowspans = 0;
    // let finalData = props.specificReportDetails.empTableData;

    // if (finalData) {
    //     var datesArr = [];
    //     var monthArr = [];
    //     var current = moment(finalData[0].startDate);
    //     monthArr.push(current.format('MM'));
    //     var end = moment(finalData[0].endDate);
    //     var templength = [];
    //     //datesLength[current.format('MM')] = 1
    //     while (current <= end) {
    //         datesArr.push(current.format('YYYY-MM-DD'));
    //         templength.push(current.format('YYYY-MM-DD'));
    //         if (!monthArr.includes(current.format('MM'))) {
    //             monthArr.push(current.format('MM'));
    //             templength = []
    //             templength.push(current.format('YYYY-MM-DD'));
    //         } else {
    //             datesLength[current.format('MM')] = templength.length
    //         }

    //         current.add(1, 'days');
    //     }
    //     dates = datesArr
    //     months = monthArr

    //     const currentDate = new Date(finalData[0].startDate);
    //     const lastDate = new Date(finalData[0].endDate);
    //     console.log(datesLength)
    // }


    // useEffect(() => {

    //     //console.log("props.specificReportDetails.requestDataId:-",props.specificReportDetails)
    //     if (props.specificReportDetails.requestDataId) {
    //         getData(props.specificReportDetails.requestDataId)
    //     } else {
    //         getData(props.specificReportDetails.id)
    //     }
    // }, []);

    // const getData = async (requestedDataId) => {
    //     let empTableData = [];
    //     const cognito = new AWS.CognitoIdentityServiceProvider();
    //     // const timeReportEmpResp = await DataStore.query(TimeReportEmployee, (c) => c.time_Report_Id.eq(requestedDataId));
    //     const timeReportEmpResp = await graphQLGetAllData("listTimeReportEmployees", [{ time_Report_Id: { eq: requestedDataId } }])

    //     //console.log(timeReportEmpResp)
    //     let totallen = [];

    //     for (let i = 0; i < timeReportEmpResp.length; i++) {
    //         let response = await getTimeReportEmployeeDetails(timeReportEmpResp[i].id, finalData[0].startDate, finalData[0].endDate)
    //         totallen[i] = response.length

    //         var employeeResponses1 = await graphQLFindRecordById("getEmployee", timeReportEmpResp[i].employee_Id)
    //         // var employeeResponses1 = await DataStore.query(Employee , timeReportEmpResp[i].employee_Id);     

    //         let empName = ''
    //         let empCode = ''
    //         if (employeeResponses1) {
    //             empName = employeeResponses1.employee_name;
    //             empCode = employeeResponses1.employee_code
    //         }

    //         let data = {
    //             "id": timeReportEmpResp[i].id,
    //             "employee_Id": timeReportEmpResp[i].employee_Id,
    //             "time_Report_Id": timeReportEmpResp[i].time_Report_Id,
    //             "pay_Rate": timeReportEmpResp[i].pay_Rate,
    //             "totalEmployeeWorkingHours": timeReportEmpResp[i].totalEmployeeWorkingHours,
    //             "employeeResponseArray": response,
    //             "employeeName": empName,
    //             "userCode": empCode

    //         }

    //         //console.log(data)
    //         empTableData.push(data);
    //         if (i === timeReportEmpResp.length - 1) {
    //             let endCounter = 0;
    //             let pageNo = 2;
    //             const rows = [];
    //             console.log('empTableData.length', empTableData.length)
    //             for (let i = 16; i <= empTableData.length; i += 23) {
    //                 endCounter = i + 23;
    //                 rows.push({ 'start': i, 'empTableData': empTableData, 'end': endCounter, 'pageNo': pageNo++ })
    //             }
    //             setPages(rows)
    //             setViewEmployeeDetailsData(empTableData)
    //         }
    //     }
    //     totalRowspans = totallen.length > 0 ? totallen.sort((a, b) => b - a) : 0
    //     settotalRowspan(totalRowspans)

    //     var getTimeReportInitiate = await graphQLFindRecordById("getTimeReportInitiateReport", requestedDataId)
    //     // var getTimeReportInitiate = await DataStore.query(TimeReportInitiateReport, requestedDataId)

    //     let timeReportTransactionCycleLate = await graphQLGetAllData("listTimeReportTransactionCycles", [{ report_Id: { eq: requestedDataId } }])
    //     timeReportTransactionCycleLate = timeReportTransactionCycleLate ? timeReportTransactionCycleLate.sort((a, b) => a.createdAt.localeCompare(b.createdAt)) : [];

    //     /* const timeReportTransactionCycleLate = await DataStore.query(TimeReportTransactionCycle, (c) => c.report_Id.eq(requestedDataId), {
    //         sort: (s) => s.createdAt(SortDirection.ASCENDING)
    //     }); */
    //     console.log("timeReportTransactionCycleLate--", timeReportTransactionCycleLate);

    //     const employeeResponses = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: getTimeReportInitiate.Created_By } }])

    //     let listApprovers = []
    //     for (let i = 0; i < timeReportTransactionCycleLate.length; i++) {

    //         if (i === 0) {
    //             let obj = {
    //                 empName: employeeResponses[0].firstName + " " + employeeResponses[0].lastName,
    //                 empTitle: 'Initiator',
    //                 empCode: employeeResponses[0].employee_code,
    //                 status: 'Submitted',
    //                 date: (timeReportTransactionCycleLate[i].createdAt) ? timeReportTransactionCycleLate[i].createdAt : timeReportTransactionCycleLate[i].customUpdatedAt

    //             }
    //             setSubmittedBy(obj);
    //         }

    //         let payrollApproval;
    //         if (timeReportTransactionCycleLate[i].isApproved) {
    //             if (timeReportTransactionCycleLate[i].to_Employee_Id) {
    //                 payrollApproval = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: timeReportTransactionCycleLate[i].to_Employee_Id } }])
    //             }

    //             let pApprovalFirstName = payrollApproval ? payrollApproval[0].firstName : "";
    //             let pApprovalLastName = payrollApproval ? payrollApproval[0].lastName : "";
    //             let fullName = pApprovalFirstName + " " + pApprovalLastName
    //             let appDate = handleDateSelect(timeReportTransactionCycleLate[i].customUpdatedAt)
    //             listApprovers.push({ name: fullName, date: appDate })
    //         }
    //     }
    //     setAllApproverList(listApprovers)

    // }

    // const getTimeReportEmployeeDetails = async (timeReportEmpRespId, startDate, endDate) => {

    //     const timeReportEmpDetailsResp = await graphQLGetAllData("listTimeReportEmployeeDetails", [{ time_Report_Employee_Id: { eq: timeReportEmpRespId } }])
    //     // const timeReportEmpDetailsResp = await DataStore.query(TimeReportEmployeeDetails, (c) => c.time_Report_Employee_Id.eq(timeReportEmpRespId));

    //     let datesArray = await getDates(startDate, endDate);
    //     let finalData = [];
    //     for (let i = 0; i < datesArray.length; i++) {
    //         let getMatchDateResponse = timeReportEmpDetailsResp.filter((item) => item.date === datesArray[i]);
    //         let data;
    //         if (getMatchDateResponse.length > 0) {
    //             data = {
    //                 "date": datesArray[i],
    //                 "totalHours": getMatchDateResponse[0].totalHoursAndMinDisplay,
    //             }
    //         } else {
    //             data = {
    //                 "date": datesArray[i],
    //                 "totalHours": "-",
    //             }
    //         }
    //         finalData.push(data)
    //     }
    //     return finalData;
    // }

    // const getDates = async (startDate, endDate) => {
    //     var dates = [];
    //     var current = moment(startDate);
    //     var end = moment(endDate);
    //     while (current <= end) {
    //         dates.push(current.format('YYYY-MM-DD'));
    //         current.add(1, 'days');
    //     }
    //     return dates;
    // }

    console.log(totalRowspan)

    return (
        <>
            <div id="my-html-template" className='border px-8 '>
                <center style={{ marginTop: '10px' }}>GLENDALE UNIFIED SCHOOL DISTRICT
                    <div className='font-bold'>Time Report</div>
                </center>
                <div>
                    <div className='flex justify-between'>
                        <div className='border'>
                            <div>Account # <span>{(props.specificReportDetails.account) ? ' ' + props.specificReportDetails.account + ' ' : '_________'}</span></div>
                            <div>Daily Rate <span>{(props.specificReportDetails.dailyRate) ? '$ ' + props.specificReportDetails.dailyRate + ' USD' : '______'}</span>  or Hourly Rate <span>{(props.specificReportDetails.hourlyRate) ? '$ ' + props.specificReportDetails.hourlyRate + ' USD' : '_____'}</span></div>
                            {/* <div>Daily/ Hourly Rate -----</div> */}
                            <div className='flex gap-x-4'>
                                <div>Authorizing Board Report Date <span>{(props.specificReportDetails.authorizingBoardReportDate) ? props.specificReportDetails.authorizingBoardReportDate : '_____'}</span></div>
                                <div>Page No. <span>{(props.specificReportDetails.pageNo) ? props.specificReportDetails.pageNo : '_____'}</span></div>
                            </div>
                            <div>Type  <span>{(props.specificReportDetails.type) ? props.specificReportDetails.type : '_____'}</span></div>
                        </div>
                        <div className='border'>
                            <div>School or Dept. <span>{(props.specificReportDetails.schoolOrDeptId) ? props.specificReportDetails.schoolOrDeptId : '_____'}</span></div>
                            <div>Period From  <span>{(props.specificReportDetails.period) ? props.specificReportDetails.period : '__________'}</span> </div>
                        </div>
                    </div>

                    <div className='border mt-2'>
                        <div>Notes. <span>{(props.specificReportDetails?.Notes) ? props.specificReportDetails?.Notes : '_____'}</span></div>
                    </div>

                    {/* <div className='border border-[black] my-4'> */}
                    {/* <div className='text-center font-bold'><span>{(props.specificReportDetails.period) ? props.specificReportDetails.period : '_______________'}</span></div> */}
                    <div>

                        <><DataRow period={props.specificReportDetails.period} months={props.months} datesLength={props.datesLength} totalRowspan={props.totalRowspan} dates={props.dates} viewEmployeeDetailsData={props.viewEmployeeDetailsData} start={0} end={16} pageNo={1} /></>
                        {
                            (props.pages).map((item) => {

                                return (
                                    <>
                                        <DataRow period={props.specificReportDetails.period} months={props.months} datesLength={props.datesLength} totalRowspan={props.totalRowspan} dates={props.dates} viewEmployeeDetailsData={item.empTableData} start={item.start} end={item.end} pageNo={item.pageNo} />
                                        {/* <h2></h2> */}
                                    </>
                                );

                            })
                        }
                    </div>
                    {/* </div> */}
                    <div style={{ marginTop: "20px" }} > {/* className='absenceCode' */}
                        {
                            (props.submittedBy) ?
                                <div>
                                    <p className='float-right font-bold'><span>{'Submitted by:'}</span></p><br />
                                    <p className='float-right'> <span className='font'>{props.submittedBy.empName ? props.submittedBy.empName : null}
                                        {props.submittedBy.date ? handleDateSelect(props.submittedBy.date) : null}

                                    </span></p>  <br /> </div> : null
                        }
                        {props.allApproverList.length ?
                            <>
                                <p className='float-right font-bold'>
                                    <span>{'Approved by:'}</span>
                                </p>  <br />  </> : null}
                        {
                            (props.allApproverList).map((item) => {

                                console.log("item--", item);

                                return (
                                    <>
                                        <p className='float-right'>
                                            <span>{item.name}</span>
                                            &nbsp;<span>{item.date}</span>
                                        </p>  <br />
                                    </>
                                );

                            })
                        }

                        {
                            props.allRejectionList.length ?
                                <>
                                    <p className='float-right font-bold'>
                                        <span>{'Rejected by:'}</span>
                                    </p>  <br />  </> : null

                        }
                        {
                            (props.allRejectionList).map((item) => {
                                return (
                                    <>
                                        <p className='float-right'>
                                            <span>{item.name}</span>
                                            &nbsp;<span>{item.date}</span>
                                        </p>  <br />
                                    </>
                                );

                            })
                        }
                    </div>
                    {/* ---------------------------------------------------------------------------------------------------------------- */}
                    {/* <p className='mt-2.5 leading-10'>
                Its requested that approval be granted to assign, on a voluntary basis, <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.employeeName}</span> EID# <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data.employeeId}</span>, teacher, to a sixth period teaching assignment at <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.schoolName}</span> for the period from <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.dateFrom}</span> to <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data.dateTo}</span>.
            </p>
            <p className='mt-2.5 leading-10'>
                Subject Area Added: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.subjectName}</span> Total Staffing Allocation: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.staffAllocation}</span>
                Account Charged: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.accountCharged}</span> Current FTE Utilized: <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.fteUtilized}</span>
            </p> */}

                    {/* <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '40px', marginRight: '10px' }}>
                    <div>_________________ <br />
                        <p style={{ fontSize: '10px' }}>Principal Signature </p>
                    </div>
                    <div style={{ marginLeft: '20px' }}> ____________________<br />
                        <p style={{ fontSize: '10px' }}>Date</p>
                    </div>
                </div> */}
                    {/* <div className='mt-2.5 border-b-4 border-[black]'></div>


                    <p className='mt-2.5 leading-10'>
                        I accept, on voluntary basis, a sixth period teaching assignment at <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.schoolName}</span> for the period from <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.dateFrom}</span> to <span className='w-16 mx-8 text-[green] font-medium'>{this.props.data?.dateTo}</span>
                    </p>
                    <p className='mt-2.5 leading-10'>
                        I understand and accept this assignment under the following provisions:

                    </p>
                    <ul
                        // style={{listStyleType:'lower-alpha'}}
                        className='list-decimal mt-2.5 leading-10 pl-20'
                    >
                        <li>Payment for t he sixth period teaching assignment shall be at my hourly rate of pay,determined by dividing my daily rate of pay by five (5).</li>
                        <li>The sixth period teaching assignment will ot interfere with my regularly assigned duties.</li>
                        <li>The sixth period teaching assignment replaces my normal preparation/conference period,which will then be scheduled immediately preceding or concluding the normal worksite day.</li>
                        <li>This assignment i contingent on funding and enrollment.</li>
                    </ul> */}
                </div>
            </div>
            {/* <button className='bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center' onClick={this.generatePDF}>Generate PDF</button> */}
        </>
    )
}

export default HtmlToPdfTimeReport

const TableRow = ({ item }) => {
    return (
        <tr>
            <td className='border border-[black] '>{item.userCode}</td>
            <td className='border border-[black]'>{item.employeeName}</td>
            {/*<td className='border border-[black]'>{item.pay_Rate}</td> */}
            {
                item.employeeResponseArray.map((currentItem) => {
                    return (
                        <td className='border border-[black] text-center'>{currentItem.totalHours}</td>
                    );
                })
            }
            <td className='border border-[black] text-center'>{item.totalEmployeeWorkingHours}</td>
        </tr>
    )
};


const DataRow = ({ period, months, datesLength, totalRowspan, dates, viewEmployeeDetailsData, start, end, pageNo }) => {
    return (
        <>
            <table className='w-full border border-[black] my-3 relative top-3'>
                <thead>
                    <tr className='py-4'>
                        <th colSpan={dates?.length + 3} className='py-4 mt-2 text-center'>{(period) ? period : '_______________'}</th>
                    </tr>
                    <tr>
                        <th className='border border-[black] text-left' colSpan="2" >Employee details</th>
                        {
                            months.map((item) => {
                                return (
                                    <th className='border border-[black] text-center' colSpan={datesLength[item]}  >{moment(item, "MM").format("MMMM")}  </th>
                                );
                            })
                        }
                        <th className='border border-[black] text-center' rowSpan={totalRowspan.length > 0 ? Math.abs(totalRowspan[0] - dates.length) > 0 ? Math.abs(totalRowspan[0] - dates.length) : "2" : "2"}>Total Hrs </th>
                    </tr>
                    <tr>
                        <th className='border border-[black] text-left'>Emp ID</th>
                        <th className='border border-[black] text-left'>Emp Name</th>
                        {/*<th className='border border-[black] text-left'>Pay rate/Hr</th> */}
                        {
                            dates.map((currentItem) => {
                                return (
                                    <th className='border border-[black] text-center'>{moment(currentItem).format("DD")}</th>
                                );
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        (viewEmployeeDetailsData) ?
                            (viewEmployeeDetailsData).map((item, index) => {
                                if (index >= start && index < end) {
                                    return (
                                        <>
                                            <TableRow item={item} />
                                        </>
                                    );
                                }
                            }) : null
                    }
                </tbody>

            </table>
            {/* <div className='text-center page-numbers'>Page No {pageNo}</div> */}
        </>
    )
};

